var map = {
	"./alberto-sclocchi.jpeg": 56,
	"./background.png": 239,
	"./c-icon.png": 116,
	"./clouds.jpg": 873,
	"./cool-effect.gif": 859,
	"./css-icon.png": 378,
	"./express-icon.png": 125,
	"./flip-icon.png": 606,
	"./git-hub-proj.png": 509,
	"./github-icon.png": 786,
	"./gmail-icon.png": 772,
	"./gym-img.jpeg": 597,
	"./handlebars-icon.png": 349,
	"./html-icon.png": 776,
	"./instagram-icon.png": 589,
	"./java-icon.png": 65,
	"./javascript-icon.png": 998,
	"./linkedin-icon.png": 187,
	"./location.png": 198,
	"./mario-bros.png": 196,
	"./mongodb-icon.png": 995,
	"./node-icon.png": 565,
	"./phone-icon.png": 621,
	"./react-icon.png": 410,
	"./soccer-img.jpeg": 641,
	"./stars.jpg": 260,
	"./verified.png": 527,
	"./wordle-img.png": 800
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 907;